import axios from "axios";
import { msalService } from "@/config/useAuth";

const graphAxios = axios.create({
  baseURL: "https://graph.microsoft.com/v1.0"
});

async function getAuthorizedHeader() {
  const graphToken = await msalService().getTokenForGraph();
  return {
    headers: { Authorization: `Bearer ${graphToken}` }
  };
}

export async function getUserPhoto() {
  const config = await getAuthorizedHeader();
  const response = await graphAxios.get("/me/photo/$value", {
    ...config,
    responseType: "blob",
  });
  return URL.createObjectURL(response.data);
}

export async function getUserProfile() {
  const config = await getAuthorizedHeader();
  const response = await graphAxios.get("/me", config);

  const {
    id,
    displayName,
    givenName,
    surname,
    mail,
    userPrincipalName,
    jobTitle,
    department,
    officeLocation
  } = response.data;

  return {
    id,
    displayName,
    givenName,
    surname,
    mail,
    userPrincipalName,
    jobTitle,
    department,
    officeLocation
  };
}